import { Button, CircularProgress, Typography } from "@mui/material"
import { CenteredBox, Dialog, Stack } from "src/shared/components"
import ReportGmailerrorredOutlinedIcon from "@mui/icons-material/ReportGmailerrorredOutlined"
import { ReactElement } from "react"
const ConfirmationDialog = ({
  open,
  toggleDialog,
  onConfirm,
  subtitle,
  loading,
  closeOnConfirm = true
}: {
  open: boolean
  toggleDialog: () => void
  onConfirm: () => void
  closeOnConfirm?: boolean
  subtitle?: string | ReactElement
  loading?: boolean
}) => {
  return (
    <Dialog
      sx={{ "& .MuiPaper-root": { borderRadius: 3 } }}
      aria-hidden={false}
      fullWidth
      maxWidth="sm"
      open={open}
      toggleDialog={() => {
        if (!loading) toggleDialog()
      }}
    >
      <Stack p={2}>
        <CenteredBox>
          <ReportGmailerrorredOutlinedIcon sx={{ fontSize: "5rem" }} color="warning" />
          <Typography variant="h4">Are you Sure?</Typography>
          {typeof subtitle === "string" ? (
            <Typography variant="body2" textAlign={"center"}>
              {subtitle}
            </Typography>
          ) : (
            subtitle
          )}
        </CenteredBox>
        <Stack variant="rowCenter" spacing={2} mt={2}>
          <Button variant="outlined" disabled={loading} onClick={toggleDialog}>
            Cancel
          </Button>
          <Button
            variant="contained"
            onClick={() => {
              onConfirm()
              if (closeOnConfirm) toggleDialog()
            }}
            disabled={loading}
          >
            {loading ? <CircularProgress size={20} color="inherit" /> : "Confirm"}
          </Button>
        </Stack>
      </Stack>
    </Dialog>
  )
}

export default ConfirmationDialog
